<template src="./RecoveryAtIdA.html">
</template>
<script>
import ArrobaIdIcon from '@/components/Icons/ArrobaIdIcon';

export default {
  name: 'recovery-at-id',
  components: { ArrobaIdIcon },
  methods: {
    redirectTo(route) {
      this.$router.push({path: `${route}`})
    }
  }
}
</script>

<style lang="scss" scoped src="./RecoveryAtIdA.scss">
</style>
